var map = {
	"./en.json": "tWh6",
	"./fr.json": "372T"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wEKf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/app ^\.\/.*\.json$
// module id = wEKf
// module chunks = 0